import { useSettings } from "../lib/settings";

export default function AnnouncementBanner() {
  const { settings } = useSettings();
  if (!settings?.banner_enabled || !settings?.banner_text) return null;

  const Inner = (
    <div className="px-4 text-center font-medium tracking-[0.15em] uppercase text-[11px]" data-testid="announcement-banner">
      {settings.banner_text}
    </div>
  );

  return (
    <div className="bg-[#1A1815] text-[#D4AF37] py-2.5 overflow-hidden">
      {settings.banner_link ? (
        <a href={settings.banner_link} target={settings.banner_link.startsWith("http") ? "_blank" : "_self"} rel="noreferrer">
          {Inner}
        </a>
      ) : Inner}
    </div>
  );
}
